import {useAtom} from "jotai/index";
import {profile} from "@/atoms/profile.ts";
import st from "@/styles/AccountPage.module.scss"
import {useTranslation} from "react-i18next";
import Button from "@/ui/Button.tsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";



const EditProfile = () => {
    
    const [user] = useAtom(profile)
    const {t} = useTranslation()
    
    const edit_fields = [
        {
            field_to_change: "email",
            label: user?.email.length ? t("modify_email") : t("set_email"),
            enabled: user?.permissions.is_email_modifiable,
            onClick: () => {
                eventEmitter.emit(CommonClass.ModalEvents.SetEmail, true)
            }
        },
        
        {
            field_to_change: "phone",
            label: user?.phone.length ? t("modify_phone") : t("set_phone"),
            enabled: user?.permissions.is_phone_modifiable,
            onClick: () => {
                eventEmitter.emit(CommonClass.ModalEvents.SetPhone, true)
            }
        },
        
    ]
    
    
    return (
        <div className={st.edit_profile}>
            {edit_fields.map((x, i) => {
                return (
                    <Button
                        type={"button"}
                        outlined
                        disabled={!x.enabled}
                        onClick={() => {
                            x.onClick()
                        }}
                        key={`Edit_field_${i}`}
                    >
                        {x.label}
                    </Button>
                )
            })}
        </div>
    )
}

export default EditProfile